import React, { useEffect, useState } from 'react';  
import firebase from './../../../firebase';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Button,  Col, Form, Row } from 'react-bootstrap'; 
import ContractPDF from 'components/utilities/contract'; 
import Logo from 'components/common/Logo';
import SignatureCanvas from 'react-signature-canvas' 
import { API_URL } from 'constants'; 

const Contract = () => {
  const { id } = useParams(); 
  const [contract, setContrat] =  React.useState(null);
  const [l, setL] = React.useState(false); 
  const [validated, setValidated] = React.useState(false); 
  const [lsms, setLSMS] = React.useState(false);
  const [formd, setFrom] = React.useState({});
  const [prep, setPrep] = React.useState(false);
  const [stateLsms, setStateLsms] = useState(false)
  const [actualCode, setActualCode] = React.useState(null);
  const [usersign, setUserSign] = React.useState(null);
  const [lsignbohouse, setLsignBohouse] =  useState(false)
  let sigCanvas = React.useRef()


  const getUser = async (uid, cb) => { 
    await firebase.firestore()
      .collection("users")
      .doc(uid)
      .get()
      .then(async (docd) => {
        if (docd.exists){

          var user = docd.data();
          user.id = docd.id;
          if (user?.delete){
             cb(null)
          }else{ 
            cb(user);
          }
          
        }else{
          cb(null);
        }
      })
      .catch((error) => {
        console.log("error", error);
        cb(null);
      });
  };


  const loadCt = () =>{
    if (l) return;

    setL(true); 
  // get list clients and format
  firebase.firestore().collection('contracts').doc(id).get().then((snap)=> {
    let s = snap.data();
    s.id = snap.id
    setContrat(s);   
    if (s?.sign?.date){
      firebase.auth().onAuthStateChanged((u) => {
        if (u) {
            
          //redirection au compte
          getUser(u.uid, (user) => { 
            // console.log("user", user); 
            if (user && user?.type === 'admin'){
              setUserSign(user);
              if (user.id !== 'DW6W1XKhigeszU4sEUT14mIpR6A3'){ // Antony uniquement
                setLsignBohouse(true)
              }else{
                setLsignBohouse(false)
              }
            }
          });
        }  
      });
    }
    setL(false); 
  }).catch((error) => {
    setL(false); 
    var errorMessage = error.message;
    toast.error(errorMessage);
  })
  }

  function makeid(length) {
    let result = '';
    const characters = '0123456789';
    const charactersLength = characters.length;
    let counter = 0;
    while (counter < length) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
      counter += 1;
    }
    return result;
}



function isInternationalPhoneNumber(input) {
  // Regular expression for international phone numbers
  // This expression allows for numbers like:
  // +1234567890, +12 345 678 901, +123-4567-8901, +123.4567.8901
  var internationalPhoneNumberPattern = /^\+(?:[0-9] ?){6,14}[0-9]$/;
  return internationalPhoneNumberPattern.test(input);
}

  const sendSMS = () => {
    if (stateLsms){
      return;
    }

    firebase.firestore().collection('crm').doc(contract?.client?.value).get().then((doc)=> {
      console.log(doc.data()?.phone)
      let phone = doc.data()?.phone
      let p = "";
      if (Array.isArray(phone) && phone.length > 0){
         p = phone[0]; 
      }else{
        if (phone.includes(',')){
          let sr = [];
          let s = phone.split(',')
          s.forEach(e => {
            let sd = e.trim();
            if (sd && isInternationalPhoneNumber(sd)){
              sr.push(sd);
            }
          });
          if (sr.length > 0){
            p = sr[0];
          }
        }else{
          if (phone >= 10){
            p = phone.trim();
          }
        }
      }

      if (p && isInternationalPhoneNumber(p)){ 
        if (confirm("Je confirme avoir lu et j'accepte de recevoir mon sms de confirmation d'identité? I confirm that I have read and agree to receive my identity confirmation SMS?")){
          setStateLsms(true)
          const code = makeid(6);
          // console.log("code", code) 
          try {
            fetch(`${API_URL}sendSMS`, {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({code:code,   phone :p }),
          }).then((res) => res.json())
              .then((data) => {
                setStateLsms(false);
                console.log("data", data); 
                  if (data.success && data.result.invalidReceivers.length === 0){ 
                    setLSMS(true);
                    setActualCode(code)
                  }   else{
                    if (data.result.invalidReceivers.length){
                      alert("Votre numero de téléphone est invalide, contactez nous. Your phone number is not valid, contact us.")
                    }else{
                      alert("une erreur s'est produite, veuillez réessayer");
                  
                    }
                  }
              });
          } catch (err) {
            console.log("err", err)
            setStateLsms(false);
            alert("une erreur s'est produite");
          }
        }
      }else{
        alert("Votre numero de téléphone est invalide, contactez nous. Your phone number is not valid, contact us.")
      }
    }) 
  }

  useEffect(() => {
    if (id){
      loadCt();
    }
  }, [])


  const handleSubmit = (event) => {
    const form = event.currentTarget;
    event.preventDefault();
    event.stopPropagation();
    const bURL64 =  sigCanvas.getTrimmedCanvas().toDataURL('image/png');
    const datasign = sigCanvas.toData();
    // console.log("sigCanvas",bURL64, datasign);
    if (form.checkValidity() === false) {
        return;
    }  

    if (l){
        return;
    }
    if (formd?.sms_code && formd?.sms_code === actualCode ){
      if (bURL64 && datasign.length > 0){
        setValidated(true); 
        setL(true);
        let sign = {
          bURL64: bURL64,
          datasign:JSON.stringify(datasign),
          date: new Date(),
          code : formd?.sms_code
        }
        firebase.firestore().collection('contracts').doc(id).update({sign : sign}).then(()=>{
          // navigate('/booking/edit/'+doc.id);
          fetch(`${API_URL}sendEmailSignClient`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({link: window?.location.href, }),
          }).then((res) => res.json())
            .then((data) => { 
              
            });

          alert("Merci, nous avons bien reçu votre signature au contrat, nous vous contacterons suite a votre signature. Thanks for sign, we will contact you following your signature.")
          window.location.reload();
          setLSMS(false);
          setActualCode(null)
           
            
          
      });
  
      }else{
        alert("Signer le document est obligatoire. Your sign is required")
      }
    }else{
      alert("Code sms invalide.")
    }


    


  }


  const handleChange = e => { 
    let d = {...formd};
    d[e.target.name] = e.target.value; 
    setFrom(d);  
  };

  const sendEmailTointerlocuteur = (email, username) => { 
      fetch(`${API_URL}sendEmailTointerlocuteur`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({email:email, link: window.location.href, username : username }),
    }).then((res) => res.json())
        .then((data) => {
          setLsignBohouse(false)
          alert("Merci, nous avons bien reçu votre signature au contrat, vous pouvez maintenant le télécharger et l'envoyer au client")
          window.location.reload();

        })

  }

  const signBohouse = () => { 
    if (lsignbohouse){
      return
    }
    setLsignBohouse(true); 
    firebase.firestore().collection('contracts').doc(id).get().then((doc)=>{
      let d = doc.data();

      let sign = d.sign;
      sign.bohouse = true;
      sign.bohouse_date = new Date(); 
      firebase.firestore().collection('contracts').doc(id).update({sign : sign}).then(()=>{
      // navigate('/booking/edit/'+doc.id);  
        sendEmailTointerlocuteur(d?.interlocuteur?.email, d?.interlocuteur?.label);
      }).catch(err=> {
        setLsignBohouse(false)
        alert("Merci, mais une erreur s'est produite réessayer ")
          
      });
    }).catch(err=> {
      setLsignBohouse(false)
      alert("Merci, mais une erreur s'est produite réessayer ")
        
    });



     
  }


  return (
    <>
      <div style={{
        display: 'flex',
        justifyContent: 'space-between',
        paddingLeft: 40,
        paddingRight: 40
      }}>
        <Logo width={100}/>
        <div className="text-left"> 
        {usersign === null ? (
          <>
            <h5 className="mt-3 mb-0">Bonjour {!l && contract && contract?.client?.label}!</h5>
            <small>Voici votre contrat de location {contract?.sign ? 'signer': 'à signer'}.</small><br/> 
            <small>Here is your rental contract {contract?.sign ? 'sign' :'to be signed'}.</small> 
          </>
        ) : (
          <>
          <h5 className="mt-3 mb-0">Bonjour {`${usersign?.lastName} ${usersign?.firstName}`}!</h5>
            
          {contract?.sign?.bohouse ? (  <small>Le contrat est validé et signer par les deux parties</small>  ) : (<>
           <small>Le client a signer le contrat, a votre tour.</small><br/> 
           <Button
             type="submit"
             color="primary"
             className="mt-3 w-100"
             disabled={lsignbohouse}
             onClick={signBohouse}
           >
             {usersign.id !== 'DW6W1XKhigeszU4sEUT14mIpR6A3' ? 'Uniquement Antony Tardieu': 'Je signe bo-house'}
           </Button></>)}
           
             
          </>
        )}
        
    </div>
      </div>
      {!l && contract && <ContractPDF contract={contract} />}
 
{<>
{contract?.sign === undefined && (
  <>
   {!l && contract && prep ? (<div class="cookie-consent-banner">
        <div class="cookie-consent-banner__inner">
          <div class="cookie-consent-banner__copy">
            <div class="cookie-consent-banner__header">Signature du contrat</div>
            {!lsms && (<><div class="cookie-consent-banner__description">
            Signature électronique avancée sécurisé via sms.<br/>
            Vous allez recevoir un sms avec un code de sécurité pour valider votre identité et signer numériquement votre contrat en ligne. Veuillez lire attentivement le contrat.
            </div>
            <div class="cookie-consent-banner__description">
            Advanced electronic signature secured by SMS.<br/>
            You will receive an SMS with a security code to validate your identity and digitally sign your contract online. Please read the contract carefully.
            </div></>)}
          </div>

          <div class="cookie-consent-banner__actions">
            {lsms ? (
              <>
               <Form noValidate validated={validated} onSubmit={handleSubmit}>
               <Row className="mb-3">
                <Form.Group as={Col} md="4" controlId="sms_code">
                        <Form.Label>CODE SMS</Form.Label>
                        <Form.Control  
                            type="text"
                            required
                            value={formd.sms_code}
                            name="sms_code"
                            onChange={handleChange}
                            placeholder="678767" 
                        /> 
                        </Form.Group>
                        <Form.Group as={Col} md="6" controlId="signature" >
                          <Form.Label>Signature</Form.Label>
                          <SignatureCanvas ref={(ref) => { sigCanvas = ref }} enColor='green' canvasProps={{width: 460, height: 200, className: 'sigCanvas'  }} />
                        </Form.Group> 
                        </Row>
                        <Button type="submit" class="btn btn-success" disabled={l}>{l ? 'Chargement' : 'Je signe (I sign)'}</Button>
                        
                     
                </Form>
              </>
            ) :
            (
              <a href="#" onClick={sendSMS} class="cookie-consent-banner__cta">
                {stateLsms ? 'Chargement ...' : 'OK'}
              </a>
            )} 
             
          </div>
        </div>
      </div>) : (
        <div class="cookie-consent-banner">
          <div class="cookie-consent-banner__inner" style={{textAlign:'end'}}>
          <a  onClick={() => {setPrep(true)}} class="cookie-consent-banner__cta">
                Signer
              </a>
              </div>
        </div>
      )}
  </>
)}
</>}

     


    </>
  );
};

export default Contract;
